export default __webpack_public_path__ + "static/media/zawodnik14.c1db257f.png";